//TODO: fix trace-summary methods to use full direction name -> directionEnum, for sort indication in CloudTable
export const PAGE_SIZE = 100;

export const sortDirectionEnum = {
  ASCENDING: "asc",
  DESCENDING: "desc",
};

export const directionEnum = {
  ASCENDING: "ascending",
  DESCENDING: "descending",
};

export const sortColumnEnum = {
  NAME: "name",
  DISPLAY_NAME: "displayName",
  AVERAGE_VALUE: "averageValue",
  COUNT: "count",
  PID: "pid",
  COMMAND: "command",
  CPU: "cpu",
  MEMORY: "memory",
  PERMISSIONS: "permissions",
  ENVIRONMENT: "environment",
  CREATION_DATE: "createdAt",
  HOSTS: "hosts",
  CONTAINERS: "containers",
};

export const shadowMetricEnum = {
  SHADOW_COLOR: "transparent",
  POSITIVE: "shadowPositive",
  NEGATIVE: "shadowNegative",
};

export const popupExcludedKeysEnum = {
  SHADOW_POSITIVE: shadowMetricEnum.POSITIVE,
  SHADOW_NEGATIVE: shadowMetricEnum.NEGATIVE,
  TIME: "time",
  SUM: "sum",
};

export const summaryEnum = {
  AVERAGE: "average",
  SUM: "sum",
  MIN: "min",
  MAX: "max",
  COUNT: "count",
  DERIVATIVE: "derivative",
};

export const chartSummaryFunctionEnum = {
  DERIVATIVE: "derivative",
  MEAN: "mean",
};

export const summaryFunctionMappingList = [
  { key: chartSummaryFunctionEnum.MEAN, summary: "average" },
];

export const timeRangeTypeEnum = {
  CURRENT: "current",
  SHIFTED: "shifted",
};

export const AO_TOP_NAV_HEIGHT = 63;

export const TESSERACT_DEFAULT_HEIGHT = 86;
export const TESSERACT_COLLAPSED_HEIGHT = 45;

export const KPI_DURATION_IN_MINUTES = 5;
export const MINUTE_IN_MICROSECONDS = 60000000;

export const HTML_INJECTION_REGEXP = /&gt;|&GT;|&lt;|&LT;|<|>|&#60;|&#62;/;
